<template>
  <div class="dwj-mask">
    <div class="content">
      <div class="title">
        <p>礼品确认码</p>
        <img class="close" src="../../assets/icon-dialog-close.png" @click="handleClick" alt />
      </div>
      <div class="sub-title">
        <p>请提供一下确认码给收银员</p>
      </div>
      <div class="code">
        <p>{{code}}</p>
      </div>
      <div class="tip">
        <p>* 请勿向非工作人员展示</p>
      </div>
      <div class="btn">
        <button @click="handleClick">下次再提</button>
      </div>
      <div class="sub-tip">
        <p>提货需要核销您的彩票/积分，请准备充足的彩票以顺利完成订单</p>
        <p>商品发货需订单确认，为保证您能够正常收到货物，请尽快到收银台确认订单</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["code"],
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="less" scoped>
.dwj-mask {
  p {
    margin: 0;
  }
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    background: #fff;
    width: 80vw;
    border-radius: 10px;
    padding: 4vw;
    .title {
      text-align: center;
      font-size: 4.5vw;
      padding: 3vw;
      position: relative;
      .close {
        width: 3.5vw;
        height: 3.5vw;
        position: absolute;
        right: 1vw;
        top: 0vw;
      }
    }
    .sub-title {
      font-size: 3.5vw;
    }
    .code {
      padding: 3vw;
      font-size: 8vw;
      font-weight: bold;
      text-align: center;
      letter-spacing: 1vw;
    }
    .tip {
      text-align: center;
      color: #999;
      font-size: 3.5vw;
    }
    .btn {
      padding: 5vw;
      button {
        display: block;
        margin: 0 auto;
        background: #fff;
        outline: none;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 2vw 3vw;
        font-size: 4vw;
      }
    }
    .sub-tip {
      font-size: 3.5vw;
      color: #999;
      p:first-child {
        margin-bottom: 3vw;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/easy/confirmModal.vue